import Component from 'vue-class-component'
import {Action, Getter, Mutation} from 'vuex-class'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import GridWidget from '@payroll/grid-widget/src/component/GridWidget.vue'
import {KeyValuePair} from '@payroll/optimus-common'

@Component({})
export default class DocumentsComponent extends AfterFetchComponent {

    @Action('getDocuments', StoreNamespace.DOCS) getDocuments: any
    @Action('downloadDocument', StoreNamespace.DOCS) downloadDocument: any
    @Action('deleteDocument', StoreNamespace.DOCS) deleteDocument: any

    @Action('fetchDocumentTypes', StoreNamespace.DOCS) fetchDocumentTypes!: any
    @Mutation('setDocumentTypes', StoreNamespace.DOCS) setDocumentTypes!: any
    @Getter('documentTypes', StoreNamespace.DOCS) documentTypes!: any[]

    @Action('getPortalTypes', StoreNamespace.SEARCH) getPortalTypes!: any
    @Mutation('setPortalTypes', StoreNamespace.SEARCH) setPortalTypes!: any
    @Getter('portalTypes', StoreNamespace.SEARCH) portalTypes!: KeyValuePair[]

    private searchFields: SearchFieldModel[] = []
    private columns: GridColumn[] = []

    beforeMount() {
        this.hasFeedback = true
    }

    mounted() {
        this.fetchDocumentTypes({requestorCallback: this})
        if (this.portalTypes.length > 0) {
            this.initSearchFields()
        }
        this.initColumns()
    }

    private initSearchFields(): void {
        if (this.documentTypes.length === 0 || this.portalTypes.length === 0) {
            return
        }

        this.searchFields.push({
            label: 'portal_type',
            property: 'portalType',
            fieldType: FieldType.SELECT_FIELD,
            selectOptions: this.portalTypes,
            selectDisplay: 'description',
            unSelectFirst: true
        })
        this.searchFields.push({
            label: 'doc_classification',
            property: 'fileInnerType',
            fieldType: FieldType.SELECT_FIELD,
            selectOptions: this.documentTypes,
            selectDisplay: 'uploadFileTypeTitle',
            unSelectFirst: true
        })
        this.searchFields.push({
            label: 'by_hp_number',
            name: 'by_hp_number',
            property: 'employerHpNum',
            fieldType: FieldType.NUMBER_FIELD,
            maxValue: 999999999,
            advancedOnly: true
        })
        this.searchFields.push({
            label: 'document_name',
            name: 'document_name',
            property: 'fileName',
            fieldType: FieldType.TEXT_FIELD,
            maxLength: 500,
            advancedOnly: true
        })
        this.searchFields.push({
            label: 'file_desc',
            name: 'file_desc',
            property: 'fileRemarks',
            fieldType: FieldType.TEXT_FIELD,
            maxLength: 500,
            advancedOnly: true
        })
        this.searchFields.push({
            label: 'from_upload_date',
            property: 'uploadDateFrom',
            fieldType: FieldType.DATE_FIELD,
            advancedOnly: true
        })
        this.searchFields.push({
            label: 'to_upload_date',
            property: 'uploadDateTo',
            fieldType: FieldType.DATE_FIELD,
            advancedOnly: true
        })
        this.searchFields.push({
            label: 'employee_id_number',
            property: 'memberIdNum',
            fieldType: FieldType.TEXT_FIELD,
            maxLength: 16,
            advancedOnly: true
        })
    }

    private initColumns(): void {
        this.columns.push({property: 'portalType', header: 'portal_type'} as GridColumn)
        this.columns.push({property: 'employerName', header: 'employer_name', hideSorting: true} as GridColumn)
        this.columns.push({property: 'employerHp', header: 'hp_number'} as GridColumn)
        this.columns.push({property: 'fileName', header: 'document_name'} as GridColumn)
        this.columns.push({property: 'uploadDate', header: 'upload_date'} as GridColumn)
        this.columns.push({property: 'description', header: 'file_desc'} as GridColumn)
        this.columns.push({property: 'innerFileType', header: 'doc_classification'} as GridColumn)
        this.columns.push({property: 'fileSize'} as GridColumn)
    }

    private getGridData(searchObject: any): void {
        this.getDocuments({
            requestorCallback: this,
            requestBody: searchObject
        })
    }

    onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
        switch (requestName) {
            case 'getDocuments':
                this.$emit('successResults', data)
                break
            case 'deleteDocument':
                this.getGridData({
                    pageNumber: 0,
                    pageSize: GridWidget.DEFAULT_PAGE_SIZE
                })
                break
            case 'downloadDocument':
                this.$emit('successExport', data)
                break
            case 'getDocumentTypes':
                this.setDocumentTypes(data)
                this.searchFields = []
                this.initSearchFields()
                if (this.portalTypes.length === 0) {
                    this.getPortalTypes({requestorCallback: this})
                }
                break
            case 'getPortalTypes':
                this.setPortalTypes(data)
                this.initSearchFields()
                this.getGridData({
                    pageNumber: 0,
                    pageSize: GridWidget.DEFAULT_PAGE_SIZE
                })
                break
        }
    }

    onExportClick(data: any) {
        this.downloadDocument({
            requestorCallback: this,
            pathVariable: data.documentId
        })
    }

    onDeleteItem(data: any) {
        this.deleteDocument({
            requestorCallback: this,
            pathVariable: data.documentId
        })
    }
}